module.exports = __webpack_public_path__ + "static/media/hotspotExample.04dba0ee.jpg";